import React from "react";

import { BsTelegram, BsTwitter } from 'react-icons/bs';
import { FaWallet, FaHandHoldingUsd } from 'react-icons/fa';
import { AiOutlineSwap } from 'react-icons/ai';
import { BiLineChart, BiChevronDown } from 'react-icons/bi';

const Buysellprocess = () => {
  return (
    <>
        
        
        <section className="buysellSection padSection text-center">
            <img src="./images/earth.png" className="img-responsive earthImg" />

          <div className="container">
            <h2>TIER SYSTEM – BUYING <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg></h2>

              <div className="row text-left d-flex align-items-center justify-content-center">
                <div className="col-sm-4">
                  <div className="sn_pro">
                    <h4>Tier 1: $0-$10K USDC</h4>
                    <ul>
                      <li>3% Burn</li>
                      <li>5% Liquidity</li>
                      <li>2.5% Marketing</li>
                      <li>2% Holder & stakerreflection</li>
                      <li>2% Staker Reflection</li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="sn_pro">
                    <h4>Tier 2: $10K-$20K USDC</h4>
                    <ul>
                      
                      <li>2% Burn</li><li>
0% Liquidity</li><li>
1.5% Marketing</li><li>
1% Holder & stakerreflection</li><li>
2% Staker Reflection</li>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="sn_pro">
                    <h4>Tier 3: $20K+ USDC</h4>
                    <ul>
                      <li>1% Burn</li><li>
0% Liquidity</li><li>
1% Marketing</li><li>
1% Holder & staker reflection</li><li>
2% Staker Reflection</li>

                    </ul>
                  </div>
                </div>
              </div>
<div className="sellSec">
            <h2>TIER SYSTEM – SELLING <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg></h2>

              <div className="row text-left d-flex align-items-center justify-content-center">
                <div className="col-sm-4">
                  <div className="sn_pro">
                    <h4>Tier 1, Tier 2, Tier 3</h4>
                    <ul>
                      <li>2.5% Burn</li><li>
0.5% Liquidity</li><li>
2% Marketing</li><li>
5% Holder & staker reflection</li><li>
3% Staker Reflection</li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </section>
    </>
  );
};

export default Buysellprocess;